/* src/app/shared/components/tracking-tracker-filter/tracking-tracker-filter.component.scss */
.consolidation-filter {
  width: 200px;
  margin-right: 5px;
}
.consolidation-filter .form-control {
  height: 40px;
  font-size: 0.8rem;
}
/*# sourceMappingURL=tracking-tracker-filter.component.css.map */
